import React from "react";
import { Search } from "lucide-react";
import { TspCard, TspTable, TspBreadcrumb } from "../../components/primitives";
import tspLocationsMockData from "../../mock/tspLocationsMockData";

export default function TspLocationsPage() {
  const columns = [
    {
      key: "city",
      label: "Taluka / Town / Municipality",
    },
    { key: "state", label: "State" },
    { key: "visits", label: "Times Visited", align: "right" },
    { key: "lastVisited", label: "Last Visited" },
    { key: "avgRating", label: "Avg Rating", align: "right", render: (row) => `★ ${row.avgRating}` },
    { key: "totalBooks", label: "Total Books", align: "right" },
  ];

  return (
    <div className="tsp-page">
      <div className="tsp-page-heading-row">
        <div>
          <h1>Location Repository</h1>
          <TspBreadcrumb items={["Dashboard", "Locations"]} />
        </div>
      </div>

      <div className="tsp-journey-filters">
        <div className="tsp-search tsp-journey-search">
          <Search size={16} />
          <input type="text" placeholder="Search talukas / towns..." aria-label="Search locations" />
        </div>
      </div>

      <TspCard title="Previously Visited Locations">
        <TspTable columns={columns} rows={tspLocationsMockData.records} rowKey="id" />
      </TspCard>
    </div>
  );
}
